import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6c2814ad"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "communication"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "row"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "l"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "卫辉市蓝天环保材料有限公司")], -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "custom-title",
    style: {
      "text-align": "left"
    }
  }, "组织架构", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "custom-title",
    style: {
      "text-align": "left"
    }
  }, "商砼砂浆站", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "custom-title",
    style: {
      "text-align": "left"
    }
  }, "组织架构", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_search = _resolveComponent("van-search");
  var _component_van_cell = _resolveComponent("van-cell");
  var _component_van_collapse_item = _resolveComponent("van-collapse-item");
  var _component_van_collapse = _resolveComponent("van-collapse");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_search, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.value = $event;
    }),
    placeholder: "请输入搜索关键词",
    shape: "round"
  }, null, 8, ["modelValue"]), _hoisted_2, _createVNode(_component_van_collapse, {
    modelValue: _ctx.activeNames,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_collapse_item, {
        name: "1"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            icon: "shop-o"
          }, {
            title: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, null, {
            title: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_van_collapse_item, {
        name: "2"
      }, {
        title: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            icon: "shop-o"
          }, {
            title: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}